import * as React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { getCookie } from '../services/Cookies';

export default function ModelDataDocumentationModal({ item, variant, open, setOpen }) {
    variant;
    const iframeRef = React.useRef(null);
    const docUrl = (item.documentation) ? item.documentation.documentation_url + '?token=' + getCookie('accessToken') : null;

    React.useEffect(() => {
        const loadContent = async () => {
            try {
              // Fetch the content through a proxy endpoint
              const response = await fetch(docUrl);

              if (!response.ok) {
                throw new Error('Failed to fetch documentation');
              }

              const html = await response.text();

              // Write the content to the iframe
              const doc = iframeRef.current.contentDocument;
              doc.open();
              doc.write(html);
              doc.close();

              // Resize the iframe
              const resizeIframe = () => {
                const height = doc.body.scrollHeight;
                // setIframeHeight(`${height}px`);
              };

              // Resize after images and other resources are loaded
              if (doc.readyState === 'complete') {
                resizeIframe();
              } else {
                doc.addEventListener('load', resizeIframe);
              }

            } catch (error) {
            //   console.error('Error loading documentation:', error);
              // Handle error (e.g., display an error message in the iframe)
            }
          };
          loadContent();
      }, []);


    return (
        <Transition appear show={!!open} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-50"
                onClose={(e) => {
                    setOpen(false);
                }}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-[90%] h-[88vh] transform overflow-hidden rounded-lg bg-white shadow-xl transition-all">
                                <div className="flex justify-end">
                                    <button
                                        className="mr-2 mt-2 p-1 hover:bg-slate-100 rounded transition-colors"
                                        onClick={(e) => {
                                            setOpen(false);
                                            e.stopPropagation();
                                        }}
                                    >
                                        <span className="material-symbols-outlined text-[20px]">close</span>
                                    </button>
                                </div>

                                <div className="flex justify-start">
                                    <button
                                        className="ml-4 -mt-2 mb-2 h-10 w-40 rounded-lg bg-black text-white hover:bg-white/15 transition-colors flex items-center justify-center gap-1"
                                        onClick={async() => {
                                            window.open(item.documentation.documentation_url + '?token=' + getCookie("accessToken"), '_blank')
                                        }}
                                    >
                                        <span className="ml-1 text-white">Open in docs</span>
                                        <span className="material-symbols-outlined text-[28px] text-white -ml-2">arrow_outward</span>
                                    </button>
                                </div>

                                <div className="h-[85%]">
                                    <iframe
                                        ref={iframeRef}
                                        src={docUrl}
                                        title={`Documentation`}
                                        width="100%"
                                        height="100%"
                                        style={{
                                            overflowY: 'scroll',
                                        }}
                                        frameBorder="0"
                                    />
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )

}
